/**
 * Router
 */

// React
import React, { Fragment, useContext } from 'react';
import { Switch, Route, withRouter, useLocation } from 'react-router-dom';
import Wos from './without-sidemenu';
import Ws from './with-sidemenu';
import AuthContext from './authContext';
// Context

// Components
//Admin
import AssignOrder from './pages/assignOrder';
import WarehouseAdminOrders from './pages/orders/warehouseAdminIndex';
import { ProductLog } from './pages/warehouseInventory/productLog';
import WarehouseInventoryLogs from './pages/warehouseInventory/log';
import WarehouseInventory from './pages/warehouseInventory';
import WarehouseInventoryHistory from './pages/warehouseInventory/warehouseInventoryHistory';
import ParcelOperators from './pages/parcelOperator';
import WarehouseZones from './pages/warehouseZones';
import WarehouseZoneAisle from './pages/warehouseZone-aisles';
import WarehouseZoneUnit from './pages/warehouseZone-unit';
import WarehouseZoneRow from './pages/warehouseZone-row';
import WarehouseZoneColumn from './pages/warehouseZone-column';
import ParcelsSender from './pages/parcelsSender';
import WarehouseAdminParcelsReceipt from './pages/warehouseAdminParcelsReceipt';
import CreateExitParcels from './pages/parcelsExit/Add/add';
import ParcelExitDetails from './pages/parcelExitDetails';
import parcelQuarantineDetails from './pages/parcelQuarantineDetails';
import CreateParcelQuarantine from './pages/quarantineWarehouse/components/add';
import ParcelWarehouseDetails from './pages/parcelWarehouseDetails';
import WarehouseAdminCancelledOrders from './pages/canceledOeders/warehouseAdminIndex';
import OrderReceiptsBulk from './pages/orders/receipt-bulk';
import ParcelPartnerDetails from './pages/parcelPartnerDetails';
import QuarantineWarehouse from './pages/quarantineWarehouse';

//operator
import Can from './components/Can';
import Login from './pages/login';
import OrderDetails from './pages/orderDetails';
import OrderDetailsMob from './pages/orderDetails/indexMob';
import OrderPick from './pages/orderPick';
import OrderPack from './pages/orderPack';
import OrderLogs from './pages/orderLogs';
import OrderReceipts from './pages/orderDetails/receipt';
import WarehouseOperatorOrders from './pages/orders/warehouseOperatorIndex';
import WarehouseOperatorOrdersMob from './pages/orders/warehouseOperatorIndexMob';
import ParcelDetails from './pages/parcelDetails';
import ParcelDetailsMob from './pages/parcelDetails/indexMob';
import WarehouseAdminUser from './pages/warehouseAdminUser';
import ParcelItemDetails from './pages/parcelItemDetails';
import ParcelItemDetailsMob from './pages/parcelItemDetails/indexMob';
import ParcelReceipts from './pages/parcelDetails/receipt';
import ParcelOutgoingReceipts from './pages/parcelDetails/outgoingReceipt';
import ParcelInventoryItems from './pages/parcelInventoryItems';
import InventoryItemsSubmit from './pages/inventoryitemssubmit';
import ParcelLocateInventoryItems from './pages/parcelLocateInventoryItems';
import ParcelUnloadInventoryItems from './pages/parcelUnloadInventoryItems';
import ParcelsWarehouseOperator from './pages/parcels/warehouseOperatorIndex';
import ParcelsWarehouseOperatorMob from './pages/parcels/warehouseOperatorIndexMob';
import ParcelLogs from './pages/parcelLogs';
import PrintLabels from './pages/parcelInventoryItems/printLabel';
import RelocateByItem from './pages/relocate/byItem';
import CancelledOrders from './pages/canceledOeders';
import AssignCancellationOrder from './pages/assignCancellationOrder';
import orderInventoryItems from './pages/orderLocateInventoryItems/orderInventoryItems';
import ExitReceipt from './pages/orderPack/components/exitRecipt';
import PackingManagement from './pages/packageManagement';
import MobileHome from './pages/mobileHome';
import CreateBundle from './pages/createBundle';
import CreateBundleWithExcel from './pages/bundlewithexcel';
import EditBundle from './pages/bundles/edit';


//supervisor
import Warehouses from './pages/warehouses';
import WarehouseDetails from './pages/warehouseDetails';
import WarehouseAssignUser from './pages/warehouseDetails/assign-user';
import WarehouseChildren from './pages/warehouseChildren';
import WarehouseInventoryDetails from './pages/warehouseInventory/warehouseInventoryDetails';
import SkusInventoryDetails from './pages/warehouseInventory/skuInventoryDetails';
import CentersStatistics from './pages/centerStatistics/index';
import CentersStatisticsDetails from './pages/centerStatistics/details';
import Parcels from './pages/parcels';
import EditProduct from './pages/editProduct';

//exchange
import Bundles from './pages/bundles';
import DeliverToDriver from './pages/bundles/deliverToDriver';
import DeliverToDriverReceipt from './pages/bundles/components/deliverToDriverReceipt';
import BundleDetails from './pages/bundleDetails';
import OrganizeBundles from './pages/organizeBundles';
import bundleLogs from './pages/bundleLogs';
import DepoOrders from './pages/depoOrders';
import GroupingCreateOrder from './pages/depoOrders/components/groupingCreate';
import AssignToDriver from './pages/assignToDrivers';
import Signature from './pages/signatureCapture';
import Print3pl from './pages/orders/components/print3pl/receipt';
import Profile from './pages/profile';
import Dimension from './pages/dimension';
import OperatorAssignment from './pages/operatorAssignment';
import RelocateByUnit from './pages/relocate/byUnit';
import Ticketing from './pages/ticketing';
import TicketDetails from './pages/ticketDetail';
import * as Sentry from '@sentry/react';


// Type
export type Routes = RouteInterface[];
export type RouteInterface = {
  component: Function;
  path: string;
  routes?: string;
};

const SentryRoute = Sentry.withSentryRouting(Route);
Sentry.init({
  dsn: "https://6e41a0b0b6cb02b7fe297fa8e50b033c@o4506965113110528.ingest.us.sentry.io/4506998418571264",
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    // or
    Sentry.reactRouterV4BrowserTracingIntegration({ history }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

// Const routes
export const routes: Routes = [
  //warehouse-operator
  {
    path: '/warehouse-operator-orders',
    component: WarehouseOperatorOrders,
    //bemoon
  },
  {
    path: '/warehouse-operator-orders-mob',
    component: WarehouseOperatorOrdersMob,
    //bemoon
  },
  {
    path: '/operator-assignment',
    component: OperatorAssignment,
    //bemoon
  },
  {
    path: '/mobile-home',
    component: MobileHome,
    //wos
  },
  {
    path: '/packing-management',
    component: PackingManagement,
    //bemoon
  },
  {
    path: '/orders/:id',
    component: OrderDetails,
    //bemoon
  },
  {
    path: '/orders-mob/:id',
    component: OrderDetailsMob,
    //bemoon
  },
  {
    path: '/warehouse-operator-orders/:id/pick',
    component: OrderPick,
    //bemoon
  },
  {
    path: '/warehouse-operator-orders/:id/pack',
    component: OrderPack,
    //bemoon
  },
  {
    path: '/orders/receipts/:id',
    component: OrderReceipts,
    //wos
    //bemoon
  },
  {
    path: '/orders/exit-receipts/:id',
    component: ExitReceipt,
    //wos
    //bemoon
  },
  {
    path: '/login',
    component: Login,
    //wos
    //bemoon
  },
  {
    path: '/ticketing',
    component: Ticketing,
    //wos
    //bemoon
  },
  {
    path: '/ticketing/:id',
    component: TicketDetails,
    //wos
    //bemoon
  },
  {
    path: '/orders/:id/allLogs',
    component: OrderLogs,
    //bemoon
  },
  {
    path: '/create-grouping-order',
    component: GroupingCreateOrder,
    //bemoon
  },
  {
    path: '/parcels-warehouse-operator',
    component: ParcelsWarehouseOperator,
    //bemoon
  },
  {
    path: '/parcels-warehouse-operator-mob',
    component: ParcelsWarehouseOperatorMob,
    //bemoon
  },
  {
    path: '/parcels/:id/allLogs',
    component: ParcelLogs,
    //bemoon
  },
  {
    path: '/parcels/details/:id',
    component: ParcelDetails,
    //bemoon
  },
  {
    path: '/parcels-mob/details/:id',
    component: ParcelDetailsMob,
    //bemoon
  },
  {
    path: '/parcels/receipts/:id',
    component: ParcelReceipts,
    //wos
    //bemoon
  },
  {
    path: '/parcels/outgoing-receipts/:id',
    component: ParcelOutgoingReceipts,
  },
  {
    path: '/print-labels/:id',
    component: PrintLabels,
    //wos
    //bemoon
  },
  {
    path: '/relocate/by-item',
    component: RelocateByItem,
    //bemoon
  },
  {
    path: '/relocate/by-unit',
    component: RelocateByUnit,
    //bemoon
  },
  {
    path: '/dimension',
    component: Dimension,
    //bemoon
  },
  {
    path: '/parcel/:id/inventory-items',
    component: ParcelInventoryItems,
    //bemoon
  },
  {
    path: '/parcel/:id/inventory-items/submit',
    component: InventoryItemsSubmit,
    //bemoon
  },
  {
    path: '/parcel/:id/locate-inventory-items',
    component: ParcelLocateInventoryItems,
    //bemoon
  },
  {
    path: '/order/:id/cancellation/:cancellationId/locate-inventory-items',
    component: orderInventoryItems,
    //bemoon
  },
  {
    path: '//:id/locate-inventory-items',
    component: ParcelLocateInventoryItems,
    //bemoon
  },
  {
    path: '/parcel/:id/unload-inventory-items',
    component: ParcelUnloadInventoryItems,
  },
  {
    path: '/edit-product/:id',
    component: EditProduct,
  },
  {
    path: '/parcel-item/details/:id',
    component: ParcelItemDetails,
  },
  {
    path: '/parcel-item-mob/details/:id',
    component: ParcelItemDetailsMob,
  },
  //warehouse-admin
  {
    path: '/assign-order/:id',
    component: AssignOrder,
  },
  {
    path: '/assign-cancellation-order/:id',
    component: AssignCancellationOrder,
  },
  {
    path: '/orders/receipt/bulk',
    component: OrderReceiptsBulk,
    //wos
  },
  {
    path: '/warehouse-admin-orders',
    component: WarehouseAdminOrders,
  },
  {
    path: '/warehouses/product-history',
    component: ProductLog,
  },
  {
    path: '/parcels-operators/:id/warehouse/:warehouseId',
    component: ParcelOperators,
  },
  {
    path: '/parcels-exit/add',
    component: CreateExitParcels,
  },
  {
    path: '/parcels-exit/details/:id',
    component: ParcelExitDetails,
  },
  {
    path: '/parcels-quarantine/details/:id',
    component: parcelQuarantineDetails,
  },
  {
    path: '/parcels-quarantine/add',
    component: CreateParcelQuarantine,
  },
  {
    path: '/parcels-warehouse/details/:id',
    component: ParcelWarehouseDetails,
  },
  {
    path: '/parcels-partner/details/:id',
    component: ParcelPartnerDetails,
  },
  {
    path: '/warehouses/your-inventory/log/:id',
    component: WarehouseInventoryLogs,
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/warehouse-zones',
    component: WarehouseZones,
  },
  {
    path: '/warehouse-zones/aisle/:id',
    component: WarehouseZoneAisle,
  },
  {
    path: '/warehouse-zones/unit/:id',
    component: WarehouseZoneUnit,
  },
  {
    path: '/warehouse-zones/row/:id',
    component: WarehouseZoneRow,
  },
  {
    path: '/warehouse-zones/column/:id',
    component: WarehouseZoneColumn,
  },
  {
    path: '/warehouses/your-inventory',
    component: WarehouseInventory,
  },
  {
    path: '/warehouses/inventory/:warehousesId/log/:skuId',
    component: WarehouseInventoryHistory,
  },
  {
    path: '/parcels-sender',
    component: ParcelsSender,
  },
  {
    path: '/warehouse-admin-parcels-receipts',
    component: WarehouseAdminParcelsReceipt,
  },
  {
    path: '/warehouse-admin-user',
    component: WarehouseAdminUser,
  },
  {
    path: '/create-bundle',
    component: CreateBundle,
  },
  {
    path: '/create-bundle-with-excel',
    component: CreateBundleWithExcel,
  },
  {
    path: '/edit-bundle/:id',
    component: EditBundle,
  },
  //warehouse-supervisor
  {
    path: '/warehouses',
    component: Warehouses,
  },
  {
    path: '/warehouses/details/:id',
    component: WarehouseDetails,
  },
  {
    path: '/warehouses/assign-user/:id',
    component: WarehouseAssignUser,
  },
  {
    path: '/warehouses/children/:warehousesId',
    component: WarehouseChildren,
  },
  {
    path: '/warehouses/inventory',
    component: WarehouseInventory,
  },
  {
    path: '/warehouses/inventory/:warehousesId',
    component: WarehouseInventoryDetails,
  },
  {
    path: '/skus/inventory/:skuId/:name',
    component: SkusInventoryDetails,
  },
  {
    path: '/centersStatistics',
    component: CentersStatistics,
  },
  {
    path: '/centersStatistics/details/:id/:nameCenter',
    component: CentersStatisticsDetails,
  },
  {
    path: '/parcels',
    component: Parcels,
  },
  {
    path: '/canceled-orders',
    component: CancelledOrders,
    //bemoon
  },
  {
    path: '/warehouse-admin-canceled-orders',
    component: WarehouseAdminCancelledOrders,
    //bemoon
  },
  {
    path: '/bundles-deliver',
    component: Bundles,
  },
  {
    path: '/bundles/:id/deliver-driver',
    component: DeliverToDriver,
  },
  {
    path: '/bundles/:id/driver',
    component: AssignToDriver,
  },
  {
    path: '/bundles/:id/driver/:vehicleId/entrance/:entranceId',
    component: Signature,
  },
  {
    path: '/organize-bundles',
    component: OrganizeBundles,
  },
  {
    path: '/deliver-driver-receipt/:id',
    component: DeliverToDriverReceipt,
  },
  {
    path: '/bundles/:id',
    component: BundleDetails,
  },
  {
    path: '/bundles/:id/allLogs',
    component: bundleLogs,
  },
  {
    path: '/depo-deliver',
    component: DepoOrders,
  },
  {
    path: '/quarantine-warehouse',
    component: QuarantineWarehouse,
  },
  {
    path: '/3pl-print-labels',
    component: Print3pl,
  },
];
const Referee = () => {
  const { pathname } = useLocation();
  const filters: string[] = [
    '/login',
    '/post-orders/receipts/',
    '/orders/receipts/',
    '/orders/exit-receipts/',
    '/orders/post/exit-receipts',
    '/orders/receipt/bulk',
    '/products/',
    '/parcels/receipts/',
    'parcels/outgoing-receipts/',
    '/print-labels/',
    '/post-print-labels/',
    '/post-orders/post-receipt',
    '/mobile-home',
    '/warehouse-operator-orders-mob',
    '/orders-mob/',
    '/parcels-warehouse-operator-mob',
    '/parcels-mob/details/',
    '/parcel-item-mob/details/',
    '/deliver-driver-receipt',
    '/3pl-print-labels'
  ];

  const wosidebare = filters.filter(route => {
    return pathname.includes(route);
  });
  return (
    <Fragment>
      <Switch>
        {wosidebare[0] == undefined ? (
          <SentryRoute path="/" component={Ws} />
        ) : (
          <SentryRoute path="/" component={Wos} />
        )}
      </Switch>
    </Fragment>
  );
};

export default withRouter(Referee);
const checkAuth = () => localStorage.getItem('token') !== null;
// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
export function RouteWithSubRoutes(route: RouteInterface) {
  const authContext = useContext(AuthContext);
  return (
    <Can
      role={authContext.user.role}
      perform={route.path}
      yes={() => (
        <SentryRoute
          exact
          path={route.path}
          render={props => {
            if (!checkAuth()) {
              window.location.reload();
              // eslint-disable-next-line react/prop-types
              props.history.push('/login');
            }
            return <route.component {...props} routes={route.routes} />;
          }}
        />
      )}
    />
  );
}
